import { Col, Row } from "@govlaunch/core";
import * as palette from "@govlaunch/palette";
import Link from "next/link";
import React from "react";
import { FormattedMessage } from "react-intl";
import LeftArrowIcon from "~/components/icons/LeftArrowIcon";

interface IVendorProfilePreviewHeaderProps {
  vendorSlug: string;
  userHasOwnerRights: boolean;
  preview: "current" | "makers" | null | undefined;
  isEnrichedProfile: boolean;
}

export default function VendorProfilePreviewHeader({
  vendorSlug,
  preview,
  isEnrichedProfile,
  userHasOwnerRights = false,
}: IVendorProfilePreviewHeaderProps) {
  if (!preview) {
    return null;
  }

  const viewingAsBasic = preview === "current";

  const basicSwitchProps = {
    padding: 4,
    ":hover": {
      opacity: 0.8,
    },
  };
  const makersSwitchProps = {
    padding: 4,
    ":hover": {
      opacity: 0.8,
    },
  };
  const notSelectedProps = {
    color: palette.darkGray,
  };
  const selectedProps = {
    backgroundImage: "linear-gradient(97deg, #086BE5 10%, #28D094 60%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontWeight: "bold",
  };

  return (
    <Row>
      <Col width={1} mb={24}>
        <div
          css={{
            display: "flex",
            width: "100%",
            alignItems: "center",
          }}
        >
          <Link
            href="/vendors/[vendorSlug]/[[...content]]"
            as={`/vendors/${vendorSlug}/${userHasOwnerRights ? "account" : "edit-vendor"}`}
            passHref={true}
          >
            <a
              css={{
                color: palette.darkGray,
                display: "flex",
                alignItems: "center",
                ":hover": {
                  opacity: 0.7,
                },
              }}
            >
              <LeftArrowIcon width={20} height={10} />{" "}
              <span css={{ marginLeft: 4 }}>
                <FormattedMessage defaultMessage="Leave Preview" id="qJ60r9" />
              </span>
            </a>
          </Link>

          {!isEnrichedProfile && (
            <div
              css={{
                marginLeft: 12,
                background: `-webkit-linear-gradient(97deg, #086BE5 10%, #28D094 60%);`,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                ":hover": {
                  opacity: 0.8,
                },
              }}
            >
              <Link href="/makers" passHref={true}>
                <a>
                  <FormattedMessage defaultMessage="Upgrade to {plan}" id="/gko4g" values={{ plan: "Makers" }} />
                </a>
              </Link>
            </div>
          )}

          <div
            css={{
              display: "flex",
              alignItems: "center",
              marginLeft: "auto",
            }}
          >
            <Link href="/vendors/[vendorSlug]?preview=1" as={`/vendors/${vendorSlug}?preview=1`} passHref={true}>
              <a
                css={
                  viewingAsBasic
                    ? {
                        ...basicSwitchProps,
                        ...(selectedProps as any),
                      }
                    : {
                        ...basicSwitchProps,
                        ...notSelectedProps,
                      }
                }
              >
                {viewingAsBasic ? (
                  <FormattedMessage defaultMessage="Viewing as {plan}" id="xN3lSr" values={{ plan: "Basic" }} />
                ) : (
                  <FormattedMessage defaultMessage="View as {plan}" id="uBVo8f" values={{ plan: "Basic" }} />
                )}
              </a>
            </Link>

            <Link
              href="/vendors/[vendorSlug]?preview=1&makers=1"
              as={`/vendors/${vendorSlug}?preview=1&makers=1`}
              passHref={true}
            >
              <a
                css={
                  viewingAsBasic
                    ? {
                        ...makersSwitchProps,
                        ...notSelectedProps,
                      }
                    : {
                        ...makersSwitchProps,
                        ...(selectedProps as any),
                      }
                }
              >
                {viewingAsBasic ? (
                  <FormattedMessage defaultMessage="View as {plan}" id="uBVo8f" values={{ plan: "Makers" }} />
                ) : (
                  <FormattedMessage defaultMessage="Viewing as {plan}" id="xN3lSr" values={{ plan: "Makers" }} />
                )}
              </a>
            </Link>
          </div>
        </div>
      </Col>
    </Row>
  );
}
